import { render, staticRenderFns } from "./BatchPayment.vue?vue&type=template&id=ac338086&scoped=true"
import script from "./BatchPayment.vue?vue&type=script&lang=js"
export * from "./BatchPayment.vue?vue&type=script&lang=js"
import style0 from "./BatchPayment.vue?vue&type=style&index=0&id=ac338086&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac338086",
  null
  
)

export default component.exports